import React from "react";
import styled from "styled-components";
// import { FaInstagram, FaFacebook } from 'react-icons/fa';
import { Logo } from "../header/header";
import { Instagram, Facebook } from "@material-ui/icons";

const Footer: React.FC = () => {
  return (
    <FooterWrapper>
      <FooterMainContainer>
        <FooterContent>
          <LogoContainer>
            <LogoWrapper>
              <Logo src="/assets/home/logo.png" alt="GetThru" />
              <LogoText>GetThru</LogoText>
            </LogoWrapper>
            <NavLinks>
              <StyledNavLink href="/gsse">GSSE</StyledNavLink>
              <StyledNavLink href="/gpep-au">GPEP AU</StyledNavLink>
              <StyledNavLink href="/bps">BPS</StyledNavLink>
              <StyledNavLink href="/gpep-nz">GPEP NZ</StyledNavLink>
            </NavLinks>
          </LogoContainer>
          <BlogsLink
            href="https://blogs.get-thru.co.nz/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blogs
          </BlogsLink>
          <SocialLinks>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram style={{ fontSize: 32 }} />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook style={{ fontSize: 32 }} />
            </a>
          </SocialLinks>
        </FooterContent>
        <Copyright>
          © Medical Education Technologies Group Ltd 2016, 82 Alexandria Road,
          Hataitai, Wellington 6021, New Zealand, +64777729830
        </Copyright>
      </FooterMainContainer>
    </FooterWrapper>
  );
};

const FooterWrapper = styled.footer`
  background-color: #1d1b3f;
  padding: 20px 0;
  color: white;
  width: 100%;
  height: 217px;
  @media (max-width: 768px) {
    height: auto;
  }
`;

const FooterMainContainer = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 20px;
`;

const FooterContent = styled.div`
  width: 100%;
  padding: 20px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    align-items: flex-start;
    padding-left: 16px;
    margin-bottom: 0;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 32px;

  a {
    color: white;
    font-size: 24px;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: 768px) {
    margin-top: 16px;
    gap: 24px;
  }
`;

const Copyright = styled.p`
  font-size: 16px;
  margin: 0;
  color: #8d899e;
  border-top: 1px solid #2c2a57;
  padding-top: 16px;
`;

const NavLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 32px;
  margin-left: 120px;
  width: 614px;

  @media (max-width: 768px) {
    margin-left: 0;
    width: 200px;
    gap: 16px 32px;
  }
`;

const StyledNavLink = styled.a`
  font-weight: 700;
  font-size: 16px;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.2s;
  flex: 0 0 calc(33.33% - 22px);

  &:hover {
    opacity: 0.8;
  }

  &:last-child {
    margin-left: 0;
    margin-right: 0;
  }

  @media (max-width: 768px) {
    flex: 0 0 calc(50% - 16px);
    text-align: left;

    &:last-child {
      margin: 0;
    }
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const LogoText = styled.span`
  font-size: 18px;
  font-weight: 800;
`;

const BlogsLink = styled.a`
  font-size: 18px;
  font-weight: 700;
  color: white;
  text-decoration: none;
  transition: opacity 0.2s;
  margin-right: 32px;
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    margin-left: 16px;
  }
`;

export default Footer;
